import colors from './colors'
import Button from './button'
import Badge from './badge'
import Stat from './stat'
import Table from './table'
import Tag from './tag'
import Alert from './alert'
import Switch from './switch'
import Tabs from './tabs'
import { extendTheme, withDefaultColorScheme } from '@chakra-ui/react'

const theme = {
  colors,
  components: {
    Button,
    Alert,
    Badge,
    Stat,
    Switch,
    Table,
    Tag,
    Tabs,
  },
  fonts: {
    body: "'Inter', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
    heading:
      "'Inter', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
  },
  styles: {
    global: {
      body: {
        bg: '#F8F9FA',
      },
    },
  },
}

export default extendTheme(
  theme,
  withDefaultColorScheme({
    colorScheme: 'brandPrimary',
    components: ['Button'],
  }),
)
